"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ReportStatisticsQuery model module.
 * @module model/ReportStatisticsQuery
 * @version 1.1.3-alpha.1
 */
class ReportStatisticsQuery {
  /**
   * Constructs a new <code>ReportStatisticsQuery</code>.
   * @alias module:model/ReportStatisticsQuery
   */
  constructor() {
    ReportStatisticsQuery.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>ReportStatisticsQuery</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReportStatisticsQuery} obj Optional instance to populate.
   * @return {module:model/ReportStatisticsQuery} The populated <code>ReportStatisticsQuery</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReportStatisticsQuery();
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('force_customer')) {
        obj['force_customer'] = _ApiClient.default.convertToType(data['force_customer'], 'Boolean');
      }
      if (data.hasOwnProperty('subscription_type_id')) {
        obj['subscription_type_id'] = _ApiClient.default.convertToType(data['subscription_type_id'], 'String');
      }
      if (data.hasOwnProperty('report_filter')) {
        obj['report_filter'] = _ApiClient.default.convertToType(data['report_filter'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ReportStatisticsQuery</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ReportStatisticsQuery</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['subscription_type_id'] && !(typeof data['subscription_type_id'] === 'string' || data['subscription_type_id'] instanceof String)) {
      throw new Error("Expected the field `subscription_type_id` to be a primitive type in the JSON string but got " + data['subscription_type_id']);
    }
    return true;
  }
}

/**
 * @member {String} customer_id
 */
ReportStatisticsQuery.prototype['customer_id'] = undefined;

/**
 * @member {Boolean} force_customer
 */
ReportStatisticsQuery.prototype['force_customer'] = undefined;

/**
 * @member {String} subscription_type_id
 */
ReportStatisticsQuery.prototype['subscription_type_id'] = undefined;

/**
 * @member {Number} report_filter
 */
ReportStatisticsQuery.prototype['report_filter'] = undefined;
var _default = ReportStatisticsQuery;
exports.default = _default;